module.exports = __webpack_public_path__ + "static/media/unloaded_active.91c21cad.svg";